import { useParams } from 'react-router-dom';
import SupBookingEditTrip from './SupBookingEditTrip';
import SupBookingEditAct from './SupBookingEditAct.jsx';

const SupBookingEdit = () => {
    const { mode } = useParams();
    console.log(SupBookingEditTrip);
    console.log(SupBookingEditAct);
    return (
        <div>
            {mode === 't' && <SupBookingEditTrip />}
            {mode === 'a' && <SupBookingEditAct />}
        </div>
    );
};

export default SupBookingEdit;
